import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import Accordion from 'components/Accordion';
import useToggle from 'hooks/useToggle';
import {
  AUTOMATION_TEMPLATE_PLACEHOLDERS,
  DEFAULT_EPISODE_TITLE,
  DEFAULT_PODCAST_TITLE,
  DYNAMIC_ELEMENTS,
} from 'utils/constants';
import { useTextOverlay } from '../../state/TextOverlayProvider';
import { getTextInfo } from '../../utils';
import TextOverlayDynamicOption from './TextOverlayDynamicOption';
import TextOverlayDynamicTextNotAvailable from './TextOverlayDynamicTextNotAvailable';
import { block } from './utils';

type TextOverlayMakeTextDynamicCardProps = {};

const TextOverlayMakeTextDynamicCard: React.FC<TextOverlayMakeTextDynamicCardProps> = () => {
  const {
    draftEditorData,
    isDynamicContentEnabled,
    isDynamicContentAvailable,
    onUpdateTextType,
  } = useTextOverlay();

  const { textValue } = getTextInfo(draftEditorData);

  const [isExpanded, onToggle] = useToggle(
    DYNAMIC_ELEMENTS.includes(textValue),
  );

  return (
    <Accordion
      isExpanded={isExpanded}
      title="Make text dynamic"
      description="Automatically add show or episode title into your video."
      className={block('container')}
      onToggle={() => onToggle(!isExpanded)}
    >
      <>
        {!isDynamicContentAvailable && <TextOverlayDynamicTextNotAvailable />}

        <Spacer
          space="12px"
          orientation="vertical"
          align="flex-start"
          justify="center"
          className={block('contents')}
        >
          <TextOverlayDynamicOption
            type="episodeTitle"
            isChecked={
              isDynamicContentEnabled &&
              (textValue === AUTOMATION_TEMPLATE_PLACEHOLDERS.episodeTitle ||
                textValue === DEFAULT_EPISODE_TITLE)
            }
            isDisabled={!isDynamicContentAvailable}
            onClick={onUpdateTextType}
          />

          <TextOverlayDynamicOption
            type="podcastTitle"
            isChecked={
              isDynamicContentEnabled &&
              (textValue === AUTOMATION_TEMPLATE_PLACEHOLDERS.podcastTitle ||
                textValue === DEFAULT_PODCAST_TITLE)
            }
            isDisabled={!isDynamicContentAvailable}
            onClick={onUpdateTextType}
          />
        </Spacer>
      </>
    </Accordion>
  );
};

export default TextOverlayMakeTextDynamicCard;
